import "./popups.css";
import { Modal, Button, Alert } from "react-bootstrap";
import { useEffect, useState } from "react";
import StarFreeIcon from "../../productdetails/Images/StarFree.svg";
import StarIcon from "../../productdetails/Images/Star.svg";
import * as Rate from "../../../network/api/rate.js";
import axios from "axios";
import { link } from "../../../config.js";
import cookies from "js-cookie";
import { useTranslation } from "react-i18next"; // Import useTranslation

const AddRate = ({
  show,
  onHide,
  id,
  setRefreshing,
  isEditing,
  userRating,
  setIsEditing,
  fetchUserRatings
}) => {
  const { t } = useTranslation(); // Initialize useTranslation
  const [commentTitle, setCommentTitle] = useState("");
  const [commentContent, setCommentContent] = useState("");
  const [rate, setRate] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const token = cookies.get("user");

  useEffect(() => {
    if (isEditing && userRating) {
      setCommentTitle(userRating.address_rate);
      setCommentContent(userRating.text_rate);
      setRate(userRating.rate);
    } else {
      setCommentTitle("");
      setCommentContent("");
      setRate(0);
    }
  }, [isEditing, userRating]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await axios.post(
        `${link}customer-reviews`,
        {
          productId: id,
          content: commentContent,
          rate: rate,
        },
        {
          headers: {
            Authorization: token,
          },
        }
      );
      setCommentContent("");
      setRate(0);
      fetchUserRatings()

      onHide();
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };



  return (
    <Modal show={show} onHide={onHide} style={{ marginTop: "200px" }}>
      <Modal.Body>
        <div className="frame-420-header d-flex justify-content-between px-2">
          <div className="mt-4">
            <h4>{isEditing ? t("updateReview") : t("addYourReview")}</h4> {/* Translation keys */}
          </div>
          <button onClick={() => onHide()}>
            <svg
              width="40"
              height="40"
              viewBox="0 0 12 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2.19526 3.13807C1.93491 2.87772 1.93491 2.45561 2.19526 2.19526C2.45562 1.93491 2.87772 1.93491 3.13807 2.19526L5.99999 5.05718L8.86189 2.19526C9.12225 1.93491 9.54438 1.93491 9.80473 2.19526C10.0651 2.45561 10.0651 2.87772 9.80473 3.13807L6.94279 5.99999L9.80473 8.86189C10.0651 9.12225 10.0651 9.54438 9.80473 9.80473C9.54438 10.0651 9.12225 10.0651 8.86189 9.80473L5.99999 6.94279L3.13807 9.80473C2.87772 10.0651 2.45562 10.0651 2.19526 9.80473C1.93491 9.54438 1.93491 9.12225 2.19526 8.86189L5.05718 5.99999L2.19526 3.13807Z"
                fill="#A5A5A5"
              />
            </svg>
          </button>
        </div>
        {success && (
          <div className="alert alert-success mt-1" role="alert">
            {success}
          </div>
        )}
        {error && <Alert variant="danger">{error}</Alert>}
        {!success && (
          <>
            <div className="add-rate-popup">
              <label>{t("reviewContent")}</label> {/* Translation key */}
              <textarea
                placeholder={t("pleaseAddYourComment")} // Translation key
                value={commentContent}
                onChange={(e) => setCommentContent(e.target.value)}
                rows="5"
                required
              ></textarea>
              <div className="add-rate">
                <p>{t("howDoYouLikeTheProduct")}</p> {/* Translation key */}
                <div className="mt-2">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <img
                      key={star}
                      src={rate >= star ? StarIcon : StarFreeIcon}
                      onClick={() => setRate(star)}
                      style={{ cursor: "pointer" }}
                      alt={`Star ${star}`}
                    />
                  ))}
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-start gap-3 p-3">
              <Button
                variant="primary"
                style={{
                  backgroundColor: "#C99700",
                  border: "none",
                  width: "50%",
                  fontSize: "18px",
                }}
                onClick={handleSubmit}
                disabled={loading}
              >
                {loading ? t("adding") : isEditing ? t("update") : t("add")} {/* Translation keys */}
              </Button>
            </div>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default AddRate;